import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-information',
  templateUrl: './billing-information.component.html',
  styleUrls: ['./billing-information.component.scss']
})
export class BillingInformationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
